import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetDipBatchChangeRequestsJobsDocument,
  type GetDipBatchChangeRequestsJobsQuery,
  type GetDipBatchChangeRequestsJobsQueryVariables,
} from "~/features/dataImportProjects/gqls";

/** Read-only BCR job stats for the DIP. */
export function useDipBatchChangeRequestsJobs(dataImportProjectId: string) {
  return useSuspenseQuery<GetDipBatchChangeRequestsJobsQuery, GetDipBatchChangeRequestsJobsQueryVariables>(
    GetDipBatchChangeRequestsJobsDocument,
    {
      variables: { dataImportProjectId },
    },
  );
}
